import { Helmet } from 'react-helmet-async';
import StructuredData from './StructuredData';

const SEO = ({
    title,
    description,
    keywords,
    image,
    url,
    type = 'website',
    structuredDataType = 'website'
}) => {
    const siteTitle = "PrepWize";
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = "Your AI-powered calorie tracker. Track nutrition, and discover delicious recipes tailored to your dietary preferences and health goals.";
    const defaultKeywords = "calorie tracker,  nutrition, healthy eating, AI macro tracker, diet tracker, recipe finder, meal prep, healthy recipes, food planning";
    const defaultImage = "/logo512.png";
    const defaultUrl = "https://prepwize.ai";

    return (
        <>
            <Helmet>
                <title>{fullTitle}</title>
                <meta name="description" content={description || defaultDescription} />
                <meta name="keywords" content={keywords || defaultKeywords} />

                {/* Open Graph */}
                <meta property="og:title" content={fullTitle} />
                <meta property="og:description" content={description || defaultDescription} />
                <meta property="og:image" content={image || defaultImage} />
                <meta property="og:url" content={url || defaultUrl} />
                <meta property="og:type" content={type} />
                <meta property="og:site_name" content={siteTitle} />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={fullTitle} />
                <meta name="twitter:description" content={description || defaultDescription} />
                <meta name="twitter:image" content={image || defaultImage} />

                {/* Canonical URL */}
                <link rel="canonical" href={url || defaultUrl} />
            </Helmet>

            <StructuredData
                type={structuredDataType}
                title={fullTitle}
                description={description || defaultDescription}
                url={url || defaultUrl}
                image={image || defaultImage}
            />
        </>
    );
};

export default SEO; 